export default {
  tenantId: (state) => state.tenant.id,
  getContract: (state) => state.contract,
  tenantSettingsKey: (state) => state.tenant.settingsKey,
  detailViewLoader: (state) => state.detailView.loading,
};
